export default "__VITE_ASSET__CFVny8ve__"